import { generateArrowMarker, generateCheckCircleMarker, generateDotMarker, generateNumeralMarker, generateXCircleMarker } from '../Marker';
const markerGenerators = {
    ['arrow']: generateArrowMarker,
    ['check-circle']: generateCheckCircleMarker,
    ['dot']: generateDotMarker,
    ['numeral']: generateNumeralMarker,
    ['x-circle']: generateXCircleMarker,
};
export const getMarkerConfig = (config, link) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const markers = {
        from: 'dot',
        to: 'dot',
    };
    if ((_a = config.linkConfig) === null || _a === void 0 ? void 0 : _a.marker) {
        if (typeof config.linkConfig.marker === 'string') {
            markers.from = config.linkConfig.marker;
            markers.to = config.linkConfig.marker;
        }
        else {
            markers.from = (_b = config.linkConfig.marker.from, (_b !== null && _b !== void 0 ? _b : markers.from));
            markers.to = (_c = config.linkConfig.marker.to, (_c !== null && _c !== void 0 ? _c : markers.to));
        }
    }
    // direct link config should supersede global config
    if (link.marker) {
        if (typeof link.marker === 'string') {
            markers.from = link.marker;
            markers.to = link.marker;
        }
        else {
            markers.from = (_d = link.marker.from, (_d !== null && _d !== void 0 ? _d : markers.from));
            markers.to = (_e = link.marker.to, (_e !== null && _e !== void 0 ? _e : markers.to));
        }
    }
    const fromMarkerId = `${link.id}-from`;
    const fromDefaultMarker = markerGenerators.dot(fromMarkerId, link);
    const toMarkerId = `${link.id}-to`;
    const toDefaultMarker = markerGenerators.dot(toMarkerId, link);
    return {
        from: {
            id: fromMarkerId,
            marker: (_h = (_g = (_f = markerGenerators)[markers.from]) === null || _g === void 0 ? void 0 : _g.call(_f, fromMarkerId, link), (_h !== null && _h !== void 0 ? _h : fromDefaultMarker)),
        },
        to: {
            id: toMarkerId,
            marker: (_l = (_k = (_j = markerGenerators)[markers.to]) === null || _k === void 0 ? void 0 : _k.call(_j, toMarkerId, link), (_l !== null && _l !== void 0 ? _l : toDefaultMarker)),
        },
    };
};
